const divPao = document.querySelector("#divPao");
const divRefeicao = document.querySelector("#divRefeicao");
const service = document.querySelector("#servico_s");

const hideElement = (el) => (el.style.display = "none");
const showElement = (el) => (el.style.display = "");

if (divPao) {
  hideElement(divPao);
}

if (divRefeicao) {
  hideElement(divRefeicao);
}

if (service) {
  service.addEventListener("change", (e) => {
    if (e.target.value === service.value) {
      if (service.value == 6 || service.value == 12 || service.value == 17) {
        hideElement(divPao);
        showElement(divRefeicao);
      } else if (service.value == 1 || service.value == 7) {
        showElement(divPao);
        hideElement(divRefeicao);
      }
    }
  });
}
